module.exports = __webpack_public_path__ + "img/DISPTCHD_RED.377205f3.svg";